"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var OutlinedInput_1 = __importDefault(require("@material-ui/core/OutlinedInput"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var BackspaceOutlined_1 = __importDefault(require("@material-ui/icons/BackspaceOutlined"));
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var TextInput_styles_1 = require("./TextInput.styles");
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return {
        clear: {
            padding: 8,
            borderRadius: 4,
            marginRight: -8,
            color: palette.text.secondary,
            "&:hover, &:focus": {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
        },
    };
}, { name: "TextInput" });
var TextInput = react_1.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h;
    var id = _a.id, label = _a.label, subLabel = _a.subLabel, search = _a.search, highlight = _a.highlight, large = _a.large, horizontal = _a.horizontal, onClear = _a.onClear, InputProps = _a.InputProps, InputLabelProps = _a.InputLabelProps, InputAdornmentProps = _a.InputAdornmentProps, inputProps = _a.inputProps, autoFocus = _a.autoFocus, autoComplete = _a.autoComplete, placeholder = _a.placeholder, inputRef = _a.inputRef, defaultValue = _a.defaultValue, value = _a.value, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, multiline = _a.multiline, rows = _a.rows, rowsMax = _a.rowsMax, rowsMin = _a.rowsMin, type = _a.type, className = _a.className, startIcon = _a.startIcon, endIcon = _a.endIcon, helperText = _a.helperText, props = __rest(_a, ["id", "label", "subLabel", "search", "highlight", "large", "horizontal", "onClear", "InputProps", "InputLabelProps", "InputAdornmentProps", "inputProps", "autoFocus", "autoComplete", "placeholder", "inputRef", "defaultValue", "value", "onChange", "onFocus", "onBlur", "multiline", "rows", "rowsMax", "rowsMin", "type", "className", "startIcon", "endIcon", "helperText"]);
    var classes = useStyles();
    var textInput = TextInput_styles_1.useTextInputStyles();
    var shouldShowStartIcon = (search && startIcon !== null) || !!startIcon;
    return (react_1.default.createElement(FormControl_1.default, __assign({ ref: ref, className: clsx_1.default(horizontal && "Por-horizontal", className) }, props),
        label && (react_1.default.createElement(FormLabel_1.default, __assign({ htmlFor: id }, InputLabelProps, { className: clsx_1.default(textInput.formLabel, InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.className) }), label)),
        subLabel &&
            (typeof subLabel === "string" ? (react_1.default.createElement(Typography_1.default, { gutterBottom: true }, subLabel)) : (subLabel)),
        react_1.default.createElement(OutlinedInput_1.default, __assign({}, InputProps, {
            id: id,
            defaultValue: defaultValue,
            value: value,
            inputRef: inputRef,
            onChange: onChange,
            onBlur: onBlur,
            onFocus: onFocus,
            autoFocus: autoFocus,
            autoComplete: autoComplete,
            placeholder: placeholder,
            multiline: multiline,
            rows: rows,
            rowsMin: rowsMin,
            rowsMax: rowsMax,
            type: type,
            inputProps: inputProps,
        }, { classes: __assign(__assign({}, InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes), { root: clsx_1.default(textInput.outlinedRoot, highlight && textInput.highlight, search && textInput.search, (_b = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _b === void 0 ? void 0 : _b.root), inputAdornedStart: clsx_1.default(textInput.inputAdornedStart, (_c = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _c === void 0 ? void 0 : _c.inputAdornedStart), adornedEnd: clsx_1.default(textInput.outlinedAdornEnd, (_d = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _d === void 0 ? void 0 : _d.adornedEnd), input: clsx_1.default(textInput.outlinedInput, large && textInput.outlinedInputLarge, (_e = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _e === void 0 ? void 0 : _e.input), notchedOutline: clsx_1.default(textInput.notchedOutline, (_f = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _f === void 0 ? void 0 : _f.input) }) }, (shouldShowStartIcon && {
            startAdornment: (react_1.default.createElement(InputAdornment_1.default, __assign({}, InputAdornmentProps, { classes: __assign(__assign({}, InputAdornmentProps === null || InputAdornmentProps === void 0 ? void 0 : InputAdornmentProps.classes), { positionStart: clsx_1.default(textInput.adornmentStart, (_g = InputAdornmentProps === null || InputAdornmentProps === void 0 ? void 0 : InputAdornmentProps.classes) === null || _g === void 0 ? void 0 : _g.positionStart) }), position: "start" }), search && !startIcon ? react_1.default.createElement(Search_1.default, { color: "disabled" }) : startIcon)),
        }), (search && {
            endAdornment: (react_1.default.createElement(IconButton_1.default, { "aria-label": "clear " + label + " input", className: clsx_1.default(classes.clear), onClick: onClear },
                react_1.default.createElement(BackspaceOutlined_1.default, { fontSize: "small" }))),
        }), (endIcon && {
            endAdornment: (react_1.default.createElement(InputAdornment_1.default, __assign({}, InputAdornmentProps, { classes: __assign(__assign({}, InputAdornmentProps === null || InputAdornmentProps === void 0 ? void 0 : InputAdornmentProps.classes), { positionEnd: clsx_1.default(textInput.adornmentEnd, (_h = InputAdornmentProps === null || InputAdornmentProps === void 0 ? void 0 : InputAdornmentProps.classes) === null || _h === void 0 ? void 0 : _h.positionEnd) }), position: "end" }), endIcon)),
        }))),
        helperText && (react_1.default.createElement(FormHelperText_1.default, { error: props.error }, helperText))));
});
TextInput.displayName = "TextInput";
exports.default = TextInput;
//# sourceMappingURL=TextInput.js.map